module.exports = __webpack_public_path__ + "img/9788993985214.ce7f86a3.jpg";